import React from "react";
import PropTypes from "prop-types";
import { TransitionGroup, CSSTransition } from "react-transition-group";

const Fader = ({ children, timeout, uKey, className }) => (
  <TransitionGroup className={className}>
    <CSSTransition key={uKey} timeout={timeout} classNames="fade">
      <div>{children}</div>
    </CSSTransition>
  </TransitionGroup>
);

Fader.defaultProps = {
  timeout: 450,
  uKey: "_key-fader"
};

Fader.propTypes = {
  timeout: PropTypes.number,
  uKey: PropTypes.string,
  className: PropTypes.string,
  children: PropTypes.oneOfType([
    PropTypes.arrayOf(PropTypes.node),
    PropTypes.node
  ])
};

export default Fader;



// WEBPACK FOOTER //
// ./src/components/common/Fader/Fader.js